import gql from 'graphql-tag';

export default gql`
  mutation deleteElement($elementId: Int!) {
    delete_elements_by_pk(element_id: $elementId) { element_id }
  }
`;
